import { StrapiMediaDTO } from "./strapi/dtos/core/media.dto";
import { getStrapiURL } from "./strapi/content";

export interface ImageProps {
  url: string;
  alternativeText: string;
  caption: string;
  width: number;  
  height: number;
}

export const getImageProps = (img: StrapiMediaDTO): ImageProps | undefined => {
  if (!img) {
    return undefined;
  }

  return getImageCoreProps(img);
};

export const getImageCoreProps = (img: StrapiMediaDTO): ImageProps | undefined => {
  if (!img || !img.url) {
    return undefined;
  }

  return {
    url: img.url.startsWith("http") ? img.url : getStrapiURL(img.url),
    alternativeText: img.alternativeText,
    caption: img.caption,
    width: img.width,
    height: img.height,
  };
};
